function HorribleSubs() {
    return (
        <>
            <div id="description">
                <p className="text-3xl mb-3">Description</p>
                <p>
                    HorribleSubs at the time was a 3rd party sub maker for anime. It was also a place to download free anime that was then eng subbed by the HorribleSubs team. At the time, there was a way to download all episodes of an anime - through the use of batch downloads, you could download the entire series.
                </p>
                <br/>
                <p>However, not every series had a batch download option. Moreover, you couldn't batch download a range of episodes, only the whole series. It was either nothing or everything. If you wanted a range of episodes, you had to click, open up the episode to reveal all the links, then click your desired method of download. It was tedious.</p>
                <br/>
                <p>That was the precursor to this project: a simple tkinter gui to basically batch click all the magnet links for a series of your choosing, and you could select the range. </p>
            </div>
            <div id="project_reflect">
                <span className="bggradienthorizontal w-full h-[1px] my-5 block"></span>
                <p className="text-3xl mb-4">Reflections</p>
                <p>
                    Yet another of my proudest projects, not because of complexity, but because of how useful it is, despite it's simplicity, as well as the fact that I did this relatively early on in my programming journey/career
               </p>
                <p>Once again, not the most ethical project, I know, but it taught me very valuable lessons in terms of how the DOM works in HTML as well as the basics of webscraping.</p>
            </div>
        </>
    );
}

export default HorribleSubs;
